import { useEffect, useState } from "react";
import { _UBLItemInvoice } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean"
import { EditorBodegaDocumentos } from "../../../../contabilidad/bodegaDocumentos/EditorBodegaDocumentos";
import { BasicPage } from "../../../../theme/Component/BasicPage"
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { DocumentStorageEditor } from "../../../../contabilidad/bodegaDocumentos/DocumentStorageEditor";

export const ConsultProyectByObligation = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_UBLItemInvoice);

    const [response, setResponse] = useState<any>()

    const getProjectByOBDocument = () => {
        instance.getProjectByOBDocument(bean.OBIDDocument, bean.OBDate).then(
            (resp: any) => {
                console.log(resp);
                setResponse(resp)
            }
        ).catch(err => console.error(err))
    }

    useEffect(() => {
        if (bean.OBIDDocument && bean.OBDate) {
            getProjectByOBDocument();
        }
    }, [bean])

    return (
        <BasicPage titulo="Consultar Proyecto por Obligación" >
            <div className="row">
                <div className="col-md-6">
                    <DocumentStorageEditor mNemonic="OB" onChange={(e) => { setBean({ ...bean, OBIDDocument: e.IDDocument, OBDate: e.DocumentDate }) }} label="Obligación" />
                </div>
                <div className="col-md-12">
                    <PrintJson json={response} />
                </div>
            </div>
        </BasicPage>
    )
}